import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import http from '../../utils/http';
import { apiRoutes } from 'routes/api';
import { handleErrorResponse } from 'utils/index';

const initialState = {
  locations: [],
  loading: false,
  error: null
};

export const getLocations = createAsyncThunk(
  'location/getLocations',
  async (_, { rejectWithValue }) => {
    try {
      const response = await http.get(apiRoutes.locations);
      return response.data.data;
    } catch (error) {
      handleErrorResponse(error);
      return rejectWithValue(error.message);
    }
  }
);

export const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLocations.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getLocations.fulfilled, (state, action) => {
        state.loading = false;
        state.locations = action.payload;
      })
      .addCase(getLocations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default locationSlice.reducer;
